var $615760f5da5ef205$exports = {};
$615760f5da5ef205$exports = {
    "more": `Meer items`
};


export {$615760f5da5ef205$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
